import React, { useCallback, useEffect, useState } from 'react';
import { AppConfig } from '@aperza/util';
import clsx from 'clsx';
import CatalogLocalNavigation from './CatalogLocalNavigation';
import TvLocalNavigation from './TvLocalNavigation';
import NewsLocalNavigation from './NewsLocalNavigation';
import style from './NavigationHeader.module.scss';
import { useAperzaUserContext } from '../AperzaUserContext';
const getTvLocalNavigation = (onTop) => {
    return (React.createElement("div", { className: clsx(style.localNavHeader, { [style.onScroll]: !onTop }) },
        React.createElement("div", { className: style.navbar },
            React.createElement(TvLocalNavigation, null))));
};
const getCatalogLocalNavigation = (onTop) => {
    return (React.createElement("div", { className: clsx(style.localNavHeader, { [style.onScroll]: !onTop }) },
        React.createElement("div", { className: style.navbar },
            React.createElement(CatalogLocalNavigation, null))));
};
const getNewsLocalNavigation = (onTop) => {
    return (React.createElement("div", { className: clsx(style.localNavHeader, { [style.onScroll]: !onTop }) },
        React.createElement("div", { className: style.navbar },
            React.createElement(NewsLocalNavigation, null))));
};
export default function LocalNavigationHeader({ fixed }) {
    const { serviceType } = useAperzaUserContext();
    const [onTop, setOnTop] = useState(true);
    const scrollCheck = useCallback(() => {
        const posY = window.scrollY;
        if (posY > 0 && onTop) {
            setOnTop(false);
        }
        if (posY === 0 && !onTop) {
            setOnTop(true);
        }
    }, [onTop]);
    useEffect(() => {
        if (fixed) {
            document.addEventListener('scroll', scrollCheck);
            return () => {
                document.removeEventListener('scroll', scrollCheck);
            };
        }
        return () => { };
    }, [scrollCheck, fixed]);
    switch (serviceType) {
        case AppConfig.APERZA_TV:
            return getTvLocalNavigation(onTop);
        case AppConfig.APERZA_CATALOG:
            return getCatalogLocalNavigation(onTop);
        case AppConfig.APERZA_NEWS:
            return getNewsLocalNavigation(onTop);
        default:
            return React.createElement(React.Fragment, null);
    }
}
